import _ from 'lodash'

export const isNilCustom = (value) => {
    return _.isNull(value) || _.isUndefined(value) || value === '';
}
export const isNotEmptyArrayInAllKeysObject = (data)=>{
    return _.some(_.keys(data),keyValue=>!_.isEmpty(data[keyValue]))
}